
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Grid, IconButton, Paper, Typography } from "@mui/material";
import brokerApi from "../../../api/brokerApi";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import helper from "../../../helper";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MdCheck } from "react-icons/md";
import { HiXMark } from "react-icons/hi2";
import staticVariablesApi from "../../../api/staticVariablesApi";
import hotelApi from "../../../api/hotelApi";
import hotelStructureApi from "../../../api/hotelStructureApi";
import reservationApi from "../../../api/reservationApi";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import CustomDateInput from "../../../Components/CustomDateInput";
import moment from "jalali-moment";
import UpdatePlanToLastForm from "./UpdatePlanToLastForm";

const UpdatePlanToLast = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);

  const [data, setData] = useState([])
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [hotelStructureIds, setHotelStructureIds] = useState([])
  const [HotelPlans, SetHotelPlans] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  const schema = yup.object().shape({
    cityConsistency: yup.string().required("شهر را انتخاب نمایید"),
    hotelId: yup.string().required("هتل را انتخاب نمایید"),
    hotelStructureId: yup.string().required("ساختار را انتخاب نمایید"),
    planCode: yup.string().required("کد پلان را انتخاب نمایید"),
    date: yup.string().required("تاریخ شروع رزرو را انتخاب نمایید")
  });
  const { handleSubmit, formState: { errors }, control, watch, resetField, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const getfilteritems = () => {
    const planCode = watch("planCode");
    //date
    let dateGregorian = null;
    if (watch("date")) {
      let date = new DateObject({
        date: watch("date"),
        calendar: persian,
        locale: persian_fa
      });

      var dateStr = date.year + '/' + date.month.number + '/' + date.day;
      dateGregorian = moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }

    const hotelStructureId = watch("hotelStructureId");

    const filterData = {
      "planCode": parseInt(planCode),
      "date": dateGregorian,
      "hotelStructureId": hotelStructureId,
    }
    return filterData;
  }

  const onSubmit = (data) => {
    const filterData = getfilteritems();
    GetData(filterData);
  };

  useEffect(() => {
    GetCityDropDown();
  }, [])

  useEffect(() => {

  }, []);
  const RefreshGrid = (result) => {
    if (result) {
      const filteritems = getfilteritems();
      GetData(filteritems);
    }
  }

  const GetData = (filterData) => {
    setLoadingRows(true)
    reservationApi.GetReservationForUpdatePlan(filterData)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingRows(false));
  }
  const columns = useMemo(
    () => [


      {
        accessorKey: 'cityConsistencyTitle',
        header: 'شهر',
        size: 100,
      },
      {
        accessorKey: 'hotelName',
        header: 'هتل',
        size: 100,
      },
      {
        accessorKey: 'planCodeTitle',
        header: 'کد پلان',
        size: 100,
      },
      {
        accessorKey: 'brokerName',
        header: 'نام کارگزار',
        size: 100,
      },
      {
        accessorKey: 'brokerCode',
        header: 'شماره کارگزار',
        size: 100,
      },
      {
        accessorKey: 'groupNumber',
        header: 'شماره گروه',
        size: 100,
      },
      {
        accessorKey: 'capacity',
        header: 'ظرفیت',
        size: 100,
      },
      {
        accessorKey: 'flightOriginName',
        header: 'مبدأ پرواز',
        size: 100,
      },
      {
        accessorKey: 'flightDestinationName',
        header: 'مقصد پرواز',
        size: 100,
      },
      {
        accessorKey: 'reservationStartDate_persian',
        header: 'شروع ',
        size: 100,
      },
      {
        accessorKey: 'reservationEndDate_persian',
        header: 'پایان ',
        size: 100,
      },
      {
        accessorKey: 'flightDate_Persian',
        header: 'تاریخ پرواز',
        size: 100,
      },

      {
        accessorKey: 'isLastEdit',
        id: 'isLastEdit',
        header: 'به روز رسانی',
        Cell: ({ cell, row }) => (
          row.original.isLastEdit ? <MdCheck size={25} color='green' /> : <HiXMark />
        ),
        size: 100,
        enableSorting: false,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableSorting: false,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#86A7FC',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
    },
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
        {
          !row.original.isLastEdit && AccessControl.checkPermissions(userPermissions, ["Reservation:UpdatePlanToLast"]) &&
          <UpdatePlanToLastForm id={row.original.id} refreshGrid={RefreshGrid} />
        }
      </Box>
    ),
  });

  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const handlePlanChanged = (id) => { }
  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    resetField("hotelStructureId")
    resetField("planCode");
    setHotels(null);
    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const handleHotelChanged = useCallback(async (id) => {
    resetField("planCode");
    setHotelStructureIds([]);
    resetField("hotelStructureId")
    if (id) {
      const hotelStructureIds = await fetchHotelStrutureDropDown(id);
      const arr = helper.DictionayToList(hotelStructureIds);
      const mappedReponse = arr.map((r) => {
        return {
          id: r.key,
          label: r.value
        };
      });
      setHotelStructureIds(mappedReponse);
      if (arr.length === 1) {
        setValue("hotelStructureId", arr[0].key);
        GetPlanHotelDropDown(arr[0].key);
      }
    }

  }, []);
  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };
  const fetchHotelStrutureDropDown = async (hotelId) => {
    try {
      let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handleHotelStructureIdChanged = async (id) => {
    if (id) {
      GetPlanHotelDropDown(id);
    }
  };

  const GetPlanHotelDropDown = (structureId) => {
    hotelStructureApi.PlanCodeHotelStructureDropDown(structureId).then(res => {
      const arr = helper.DictionayToList(res.data.data);
      SetHotelPlans(arr.map((item) => {
        return {
          id: item.key,
          label: item.value
        };
      }));
    }).catch(err => console.log(err));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <RtlProvider>
        <Typography component="h1" variant="h5" mb={2}>
          به روز رسانی پلان اقامتی
        </Typography>
        <Grid container spacing={1} mb={2}>
          <Grid item xs={12} sm={1}>
            <RHFAutocomplete
              control={control}
              options={Cities ?? []}
              name="cityConsistency"
              placeholder="شهر"
              onChange={handleCityChanged}
              disabled={Cities === null}
              error={!!errors?.cityConsistency}
              helperText={errors?.cityConsistency?.message}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={Hotels ?? []}
              name="hotelId"
              placeholder="هتل"
              onChange={handleHotelChanged}
              disabled={Cities === null}
              error={!!errors?.hotelId}
              helperText={errors?.hotelId?.message}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              loading={watch("hotelId") && !hotelStructureIds?.length}
              control={control}
              options={hotelStructureIds ?? []}
              name="hotelStructureId"
              placeholder="ساختار"
              onChange={handleHotelStructureIdChanged}
              disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
              style={{
                border: "none",
                padding: 0,
              }}
              error={!!errors?.hotelStructureId}
              helperText={errors?.hotelStructureId?.message}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <RHFAutocomplete
              control={control}
              options={HotelPlans ?? []}
              name="planCode"
              placeholder="پلان"
              onChange={handlePlanChanged}
              error={!!errors?.planCode}
              helperText={errors?.planCode?.message}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Controller
              control={control}
              name="date"
              rules={{ required: true }}
              render={({
                field: { onChange, name, value },
                fieldState: { invalid, isDirty },
              }) => (
                <>
                  <DatePicker
                    value={value || ""}
                    onChange={(date) => {
                      onChange(date?.isValid ? date : "");
                    }}
                    format={"YYYY/MM/DD"}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    render={<CustomDateInput label={"تاریخ شروع رزرو"} error={!!errors?.date}
                      helperText={errors?.date?.message} />}
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <Button type="submit" variant="contained" color="secondary">جستجو</Button>
          </Grid>
        </Grid>
        <MaterialReactTable table={table} />
      </RtlProvider>
    </form>
  );
}

export default UpdatePlanToLast;
